import * as modal from "../../util/modal.ts";
import { validate } from "../../util/forms.ts";
import * as amplify from "../../util/amplify.ts";
import * as Locale from "../../util/Locale.ts";
import * as Html from "../../util/Html.ts";
import * as i18n from "../../i18n.ts";
import * as DateUtils from "../../lib/DateUtils.ts";
import {openLimitModal,openCategoryLimitModal} from "../../ui/modal/budgetModal.ts";
import ApiServer from "../../ApiServer.ts";
import {guessCurrency} from "../../lib/Currency.ts";
import * as Confetti from "../../lib/Confetti.ts";
import * as FwDatas from "../../FwDatas.ts";
import {getCache,setCurrentBudget,getCurrentBudget,buildTransactionList,buildSummary} from "../../server/objects/BudgetBeans.ts";


const {budgetCache,budgetCategoryCache,budgetPaymentMethodCache,budgetTransactionCache} = getCache();

var souscription = undefined
function destroyDom(form: HTMLElement){
  amplify.unsubscribe('budgetmodified',souscription)
}
function initDom(form: HTMLElement){
  var
    metaId = Html.getDomMetaId(form),
    budgetBean = metaId?budgetCache.get(metaId).cloneWith({}):new ApiServer.types.BudgetBean({
      name:"",
      budgetLimit:"1000",
      budgetLimitActive:"false",
      currencyCode:guessCurrency(),
      recurrency:"MONTHLY",
      recurrencyStartDay:1,
      budgetCategoryLimits:{},
      sharedToAll:"true",
      paidUsage:"NONE",
      sharedMemberIds:[],
      accountId:FwDatas.getAccountId(),
      rights:{}
      }),
    name = form.querySelector('input[name=name]') as HTMLInputElement,
    emoji = form.querySelector('input[name=emoji]') as HTMLInputElement,
    isrecurrent = form.querySelector('select[name=isrecurrent]') as HTMLSelectElement,
    recurrency = form.querySelector('select[name=recurrency]') as HTMLSelectElement,
    recurrencyStartDay = form.querySelector('select[name=recurrencyStartDay]') as HTMLSelectElement,
    budgetLimit = form.querySelector('input[name=budgetLimit]') as HTMLInputElement,
    budgetCategoryLimits = form.querySelector('input[name=budgetCategoryLimits]') as HTMLInputElement,
    currencyCode = form.querySelector('select[name=currencyCode]') as HTMLSelectElement,
    paidUsage = form.querySelector('select[name=paidUsage]') as HTMLSelectElement,
    markallaspaid = form.querySelector(".markallaspaid") as HTMLElement,

    submit = form.querySelector('*[type=submit]') as HTMLElement;

  amplify.subscribe('budgetmodified',updateUI)
  souscription = updateUI
  function updateUI(recurrencyChanged ?:boolean){
    name.value = budgetBean.name;
    submit.classList.toggle("secondary", name.value.trim().length===0)

    if(budgetBean.budgetLimitActive){
      budgetLimit.value = budgetBean.formatAmount(budgetBean.budgetLimit);
    }else{
      budgetLimit.value = '';
    }

    isrecurrent.value = ""+(budgetBean.recurrencyDescriptor.recurrency!=='NONE');

    var
      isRecurrent = budgetBean.recurrencyDescriptor.recurrency!=='NONE';

    const recurrencyLabel = recurrency.closest('label') as HTMLElement;
    if(recurrencyLabel) recurrencyLabel.style.display = isRecurrent ? '' : 'none';
    recurrency.value = budgetBean.recurrencyDescriptor.recurrency;

      switch(budgetBean.recurrencyDescriptor.recurrency){
        case 'YEARLY':{
          const yearlyLabel = recurrencyStartDay.closest('label') as HTMLElement;
          if(yearlyLabel) yearlyLabel.style.display = '';
          var
            optGroups = [],
            optionsHtml;
          DateUtils.getYearRange(new Date('2010-01-02')).getDays().forEach(day=>{
            var group = optGroups[day.date.getMonth()];
            if(group===undefined){
              group = optGroups[day.date.getMonth()] = {name:day.date.toLocaleString(i18n.getSelectedLanguage(), {month:"long"}),days:[]}
            }
            group.days.push(day)
          })
          var recurrencyStartDayInput = 1;
          optionsHtml = optGroups.map(group=>{
            var options = group.days.map((day)=>'<option '+(recurrencyStartDayInput===1?'selected':'')+' value="'+(recurrencyStartDayInput++)+'">'+day.date.toLocaleString(i18n.getSelectedLanguage(), { day:"numeric", month:"long"})+'</option>').join('')
            return '<optgroup label="'+group.name.toUpperCase()+'">'+options+'</optgroup>';
          }).join('')
          recurrencyStartDay.innerHTML = optionsHtml;
          recurrencyStartDay.value = ''+budgetBean.recurrencyStartDay;
          recurrencyStartDay.dispatchEvent(new Event('change'));
          break;
        }
        case 'MONTHLY':{
          const monthlyLabel = recurrencyStartDay.closest('label') as HTMLElement;
          if(monthlyLabel) monthlyLabel.style.display = '';
          recurrencyStartDay.innerHTML =
            '<option value="1">'+i18n.get("recurrency.firstofmonth")+'</option>'+
            [2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30].map(idx=>'<option value="'+idx+'">'+idx+'</option>').join('')+
            '<option value="-1">'+i18n.get("recurrency.lastofmonth")+'</option>';
          recurrencyStartDay.value = ''+budgetBean.recurrencyStartDay;
          recurrencyStartDay.dispatchEvent(new Event('change'));
          break;
        }
        case 'SEMI_MONTHLY':{
          const semiLabel = recurrencyStartDay.closest('label') as HTMLElement;
          if(semiLabel) semiLabel.style.display = '';
          recurrencyStartDay.innerHTML =
            '<option value="15">'+i18n.get("budget.label.semimonthly_first")+'</option>'+
            '<option value="30">'+i18n.get("budget.label.semimonthly_last")+'</option>';
          if(recurrencyChanged){
            recurrencyStartDay.value = '15';
            recurrencyStartDay.dispatchEvent(new Event('change'));
          }else{
            recurrencyStartDay.value = ''+budgetBean.recurrencyStartDay;
            recurrencyStartDay.dispatchEvent(new Event('change'));
          }
          break;
        }
        case 'BIWEEKLY':{
          const biweeklyLabel = recurrencyStartDay.closest('label') as HTMLElement;
          if(biweeklyLabel) biweeklyLabel.style.display = '';
          var
            days = [],
            rangeWithoutStart = DateUtils.getWeekRange(new Date(),budgetBean.recurrencyStartDay,2);
          for(var i=0;i<14;i++){
            var
              newRecurrencyStartDay = i+budgetBean.recurrencyStartDay,
              date = new Date(rangeWithoutStart.start);
            date.setDate(date.getDate()+i);
            if(newRecurrencyStartDay>14){
              newRecurrencyStartDay -= 14;
            }
            if(date>new Date()){
              date.setDate(date.getDate()-14);
            }
            let name;
            if(DateUtils.isSameDay(date,new Date())){
              name = i18n.get('deltatime.today')
            }else if(DateUtils.isSameDay(date,new Date(new Date().getTime()-3600000*24))){
              name = i18n.get('deltatime.yesterday')
            }else{
              name = new Intl.DateTimeFormat(i18n.getSelectedLanguage(),{month: "short", weekday:"long",day: "numeric"}).format(date)
            }
            days.push({
              recurrencyStartDay:newRecurrencyStartDay,
              date:date,
              name:name+" ("+i18n.get('timetable.week')+' '+DateUtils.getWeekNumber(date)+')'
            })
          }
          days.sort((b,a)=>{
            return a.date-b.date;
          });

          recurrencyStartDay.innerHTML =
            days.map(dayInfo=>'<option value="'+dayInfo.recurrencyStartDay+'">'+dayInfo.name+'</option>').join('');
          if(recurrencyChanged){
            recurrencyStartDay.value = ''+days[0].recurrencyStartDay;
            recurrencyStartDay.dispatchEvent(new Event('change'));
          }else{
            recurrencyStartDay.value = ''+budgetBean.recurrencyStartDay;
            recurrencyStartDay.dispatchEvent(new Event('change'));
          }
          break;
        }
        case 'WEEKLY':{
          const weeklyLabel = recurrencyStartDay.closest('label') as HTMLElement;
          if(weeklyLabel) weeklyLabel.style.display = '';
          recurrencyStartDay.innerHTML =
            DateUtils.getWeekDays().map(day=>'<option value="'+day.index+'">'+day.name+'</option>').join('');
          recurrencyStartDay.value = ''+budgetBean.recurrencyStartDay;
          recurrencyStartDay.dispatchEvent(new Event('change'));
          break;
        }
        default:{
          const defaultLabel = recurrencyStartDay.closest('label') as HTMLElement;
          if(defaultLabel) defaultLabel.style.display = 'none';
          recurrencyStartDay.innerHTML = '';
        }

      }

  }
  name.addEventListener('input',function(){
    submit.classList.toggle("secondary", name.value.trim().length===0)
  })
  name.addEventListener('change',function(){
    budgetBean.name = name.value;
  })
  paidUsage.addEventListener('change',function(){
    budgetBean.paidUsage = paidUsage.value;
    if(budgetBean.paidUsage === 'PAID'){
      const
        rangeUntilToday = DateUtils.getRangeUntil(DateUtils.getEndOfDay(new Date())),
        transactionsUnPaid = budgetBean.getTransactionList(rangeUntilToday).filter(transaction=>!transaction.isPaid());
      if(transactionsUnPaid.length>0){
        modal.ask({
          h2:"budget.updatepast",
          message:"budget.updatepasttext",
          lottie:'images/lottie/face_with_monocle.json',
          button:[{
            title:'budget.updatepastok',
            onclick:()=>{
              ApiServer.budgetmarkaspaid(transactionsUnPaid.map(t=>t.metaId)).then((result)=>{
                modal.toastDone('budget.pasttransactionpaid',transactionsUnPaid.length)
              })
              amplify.publish("budgetNeedRefresh")
            },
          },{
            title:'budget.updatepastcancel',
            action:"modalclose",
            class:"secondary"
          }]
        })
      }
    }
  })
  markallaspaid.addEventListener('click',function(){
    const
      rangeUntilToday = DateUtils.getRangeUntil(DateUtils.getEndOfDay(new Date())),
      transactionsUnPaid = budgetBean.getTransactionList(rangeUntilToday).filter(transaction=>!transaction.isPaid());

    modal.ask({
      h2:"budget.updatepast",
      message:"budget.updatepasttext2",
      lottie:'images/lottie/face_with_monocle.json',
      button:[{
        title:'budget.updatepastok',
        onclick:()=>{
          if(transactionsUnPaid.length===0){
            modal.toastDone('budget.pasttransactionpaid',transactionsUnPaid.length)
            return;
          }
          ApiServer.budgetmarkaspaid(transactionsUnPaid.map(t=>t.metaId)).then((result)=>{
            modal.toastDone('budget.pasttransactionpaid',transactionsUnPaid.length)
          })
          amplify.publish("budgetNeedRefresh")
        },
      },{
        title:'budget.updatepastcancel',
        action:"modalclose",
        class:"secondary"
      }]
    })
  })
  recurrency.addEventListener('change',function(){
    budgetBean.recurrencyStartDay = 1;
    budgetBean.recurrencyDescriptor.recurrency = recurrency.value;
    updateUI(true)
  })
  recurrencyStartDay.addEventListener('change',function(){
    if(recurrency.value==='SEMI_MONTHLY'){
      var value = recurrencyStartDay.value;
      budgetBean.recurrencyStartDay =  value;
      budgetBean.recurrencyDescriptor.byMonthDay = value==='30'?'15':'1';

    }else{
      budgetBean.recurrencyStartDay = recurrencyStartDay.value;
      budgetBean.recurrencyDescriptor.byMonthDay = '';
    }
  })
  emoji.addEventListener('change',function(){
    budgetBean.emoji = emoji.value;
  })
  isrecurrent.addEventListener('change',function(){
    if(metaId && budgetBean.recurrencyDescriptor.recurrency!=='NONE'){
      modal.ask({title:"budget.switchtype.title",message:"budget.switchtype.message",button:[
        {title:"budget.actions.switch",value:"true"},
        {title:"actions.cancel",class:"secondary"}
      ],lottie:"images/lottie/face_with_monocle.json"},function(resp){
        if(resp===null){
          budgetBean.recurrencyDescriptor.recurrency='NONE'
        }
        updateUI(true);

      })
    }else{
      budgetBean.recurrencyDescriptor.recurrency = {"true":'MONTHLY',"false":'NONE'}[isrecurrent.value]
      updateUI(true);
    }
  })
  currencyCode.addEventListener('change',function(){
    budgetBean.currencyCode = currencyCode.value;
  })
  budgetCategoryLimits.addEventListener('wanachange',function(event){
    openCategoryLimitModal(budgetBean)
  })
  budgetLimit.addEventListener('focus',function(event){
    event.preventDefault();
    openLimitModal(budgetBean,undefined)
  })
  budgetLimit.addEventListener('wanachange',function(event: CustomEvent){
    event.preventDefault();
    openLimitModal(budgetBean,event.detail)
  })

  setTimeout(function(){
    updateUI();
    name.select();
  },0);

  (form as HTMLFormElement).addEventListener('submit', function(event){
    event.preventDefault();
    event.stopImmediatePropagation();
    event.stopPropagation();
    if(!validate(form as HTMLFormElement)){
      return false;
    }
    var sharedToAllInput = (form as any).sharedToAll;
    if(sharedToAllInput){
      budgetBean.sharedToAll = sharedToAllInput.value === 'true';
  	  var checkedUsers = (form as any).sharedMemberIds.querySelectorAll("option:checked");
      budgetBean.sharedMemberIds = Array.from(checkedUsers).map((el:HTMLOptionElement) => el.value);
    }
    if(!budgetBean.isCategoryLimitValid()){
      budgetBean.budgetLimitCategoryActive = false;
    }
    ApiServer.budgetput(budgetBean,function(){
      modal.closeDomModal();
      if(!metaId){
        Confetti.start(2000);
        modal.simple({title:"budget.createdtitle",message:"budget.created",button:"budget.gotomybudget",lottie:"images/lottie/53775.json"})
      }else{
        modal.snackDone('budget.budgetsaved')
      }
    },function(err){
      if(err.code==="63"){
        modal.oops("budget.errors.63").then(function(){
          name.selectAll()
        })
      }else{
        throw err;
      }
    })
  })
}
Html.registerWidget('widget/form/budgetForm',{initDom,destroyDom})
